import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Logo from './components/Logo';
import TestGrid from './components/TestGrid';
import WeeklyTip from './components/WeeklyTip';
import useTestFetching from './hooks/useTestFetching';
import useTestActions from './hooks/useTestActions';

const HomePage = () => {
  const location = useLocation();
  const [showYouTubeMessage, setShowYouTubeMessage] = useState(false);
  const [completedTestName, setCompletedTestName] = useState('');
  
  const { tests, loading, error } = useTestFetching({
    topic: 'MATH',
    testType: 'WEEKLY',
    endpoint: 'latest'
  });
  
  const { handleStartTest, handlePayment } = useTestActions();

  // Check if user just completed a test
  useEffect(() => {
    if (location.state?.showYouTubeMessage) {
      setShowYouTubeMessage(true);
      setCompletedTestName(location.state.testName || 'the test');
      // Clear the state to prevent showing again on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleYouTubeClick = () => {
    window.open('https://www.youtube.com/@Prepnest1111', '_blank');
  };

  const handleDismissYouTube = () => {
    setShowYouTubeMessage(false);
  };

  return (
    <div className="container">
      {/* Hero Section */}
      <div className="card" style={{ 
        textAlign: 'center',
        marginBottom: 'var(--spacing-2xl)',
        background: 'linear-gradient(135deg, var(--primary-light), var(--primary-color))',
        color: 'white'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: 'var(--font-size-3xl)',
            marginTop: 'var(--spacing-lg)',
            marginBottom: 'var(--spacing-md)'
          }}>
            Welcome to BrainyHoot
          </h1>
          <p style={{ 
            fontSize: 'var(--font-size-lg)',
            marginBottom: 'var(--spacing-xl)',
            opacity: 0.9
          }}>
            Master Your Skills With Our 360° Program. Take Assessments, Track Your Progress, Review Solutions And Sharpen Your Skills.
          </p>
        </div>
      </div>

      {/* YouTube Subscription Message */}
      {showYouTubeMessage && (
        <div className="card" style={{
          marginBottom: 'var(--spacing-xl)',
          border: '2px solid var(--primary-color)',
          backgroundColor: 'white',
          position: 'relative'
        }}>
          <button
            onClick={handleDismissYouTube}
            style={{
              position: 'absolute',
              top: 'var(--spacing-sm)',
              right: 'var(--spacing-sm)',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: 'var(--text-secondary)',
              padding: '4px',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--background-secondary)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            ×
          </button>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--spacing-md)',
            padding: 'var(--spacing-xs)',
            flexWrap: 'wrap'
          }}>
            <div style={{
              fontSize: '18px',
              cursor: 'pointer',
              flexShrink: 0
            }} onClick={handleYouTubeClick}>
              📺
            </div>
            
            <div style={{ flex: 1, minWidth: '200px' }}>
              <div style={{
                color: 'var(--text-primary)',
                fontSize: 'var(--font-size-md)',
                fontWeight: '600'
              }}>
                Great job completing{' '}
                <span style={{
                  color: 'var(--secondary-color)',
                  fontWeight: '700',
                  fontSize: 'var(--font-size-lg)'
                }}>
                  {completedTestName}
                </span>

              </div>
              <div style={{
                color: 'var(--text-secondary)',
                fontSize: 'var(--font-size-sm)',
                marginTop: '2px'
              }}>
                Subscribe to our YouTube channel for detailed solutions!
              </div>
            </div>
            
            <button
              onClick={handleYouTubeClick}
              style={{
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                border: 'none',
                padding: 'var(--spacing-xs) var(--spacing-md)',
                borderRadius: 'var(--radius-md)',
                fontSize: 'var(--font-size-sm)',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-xs)',
                transition: 'background-color 0.2s ease',
                flexShrink: 0
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--primary-dark)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--primary-color)'}
            >
              <span style={{ fontSize: '14px' }}>▶️</span>
              Subscribe
            </button>
          </div>
        </div>
      )}

      {/* Weekly Tip Section */}
      <WeeklyTip />

      {/* Latest Tests Section */}
      <section style={{ marginBottom: 'var(--spacing-2xl)' }}>
        <div className="section-header">
          <h2 className="section-title">Latest Assessments</h2>
          <div className="section-subtitle">
            Explore our latest tests across different difficulty levels
          </div>
        </div>
        <TestGrid
          tests={tests}
          onStartTest={handleStartTest}
          onPayment={handlePayment}
          variant="detailed"
          loading={loading}
          error={error}
        />
      </section>
    </div>
  );
};

export default HomePage;